module.exports = __webpack_public_path__ + "static/postcardSample2-3a2645a34932848ebe4b58057b7fadce.jpg";